/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCloudNetwork = createReactComponent("outline", "cloud-network", "IconCloudNetwork", [["path", { "d": "M3 20h7", "key": "svg-0" }], ["path", { "d": "M14 20h7", "key": "svg-1" }], ["path", { "d": "M10 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-2" }], ["path", { "d": "M12 16v2", "key": "svg-3" }], ["path", { "d": "M8 16.004h-1.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-2.535", "key": "svg-4" }]]);

export { IconCloudNetwork as default };
//# sourceMappingURL=IconCloudNetwork.mjs.map
